import React, { useState } from 'react';
import axios from "axios";
//import axios from "axios";
import { Dropdown, Button, Modal } from 'react-bootstrap';

const Mail_richiesta_dati = (props) => {

    const [value, setValue] = useState();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSubmit1 = (e) => {
        alert('scrivi qualcosa')
    }


    function Invia_mail_richiesta_dati() {
        console.log('invia_mail_richiesta_dati');
        
        let alunno_aux = props.alunno
        alunno_aux.tutor_email_inviante = props.tutor.email

        axios.post('/alunni/invia_mail_richiesta_dati/', alunno_aux)

        axios.patch('/alunni/mail_richiesta_dati/' + props.alunno._id + '/' + '0')
            .then((res) => {
                console.log(res.data)
                //                SET_variab_aggiorna(JSON.stringify(res.data))
            }).catch((error) => {
                console.log(error)
            });
        var aux = props.variab_aggiorna
        props.SET_variab_aggiorna(!aux)
        setShow(false)
    }

    return (
        <>
        <Dropdown.Item onClick={() => setShow(true)} >Mail Richiesta Dati</Dropdown.Item>

        <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Invia una mail all'alunno</Modal.Title>
        </Modal.Header>
        <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
                Annulla
            </Button>
            <Button variant="primary" onClick={Invia_mail_richiesta_dati}>
                Invia
            </Button>
        </Modal.Footer>
        </Modal>

        </>

    )
}
export default Mail_richiesta_dati;